// 组件

// import toast from '@/components/toast.vue'

const publicComs = {
    install (Vue) {
        // Vue.component('toast', toast)
    }
}

export default publicComs


// WEBPACK FOOTER //
// ./src/public/publicComs.js